import React, { Component } from "react";

class Home extends Component {

  render() {
    return (
      <div>
        <h2> LA MAISON DU FREESTYLE </h2>
        <p> Toutes les apps sont dans le menu à gauche </p>
      </div>
    );
  }
}

export default Home;
